<template>
  <div>
    <NavigationBar
      titel="Dienstgrad bearbeiten"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        v-model="helpers.formIsValid"
        ref="form"
        @submit.prevent="createItem"
      >
        <rank-editor
          v-model="rank"
          mode="edit"
          :organizationId="$route.params.organizationId"
          :itemId="$route.params.itemId"
        ></rank-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { UPDATE_RANK } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import RankEditor from "@/components/member-management/ranks/RankEditor.vue";

export default {
  name: "member-management-rank-edit",
  components: {
    NavigationBar,
    RankEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.updateItem,
        },
      ],

      helpers: {
        formIsValid: false,
      },
      rank: null,
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("ranks")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.rank = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    updateItem() {
      this.validate();

      if (this.helpers.formIsValid) {
        var res = confirm(
          "Bist Du sicher, dass Du diesen Dienstgrad aktualisieren möchtest?\n\nEs werden die Dantesätze aller Mitglieder angepasst, die diesen Dienstgrad aktuell inne haben?"
        );
        if (res == true) {
          this.$store.dispatch(`${MEMBER_MANAGEMENT}${UPDATE_RANK}`, {
            organizationId: this.$route.params.organizationId,
            itemId: this.$route.params.itemId,

            title: this.rank.title,
            shortTitle: this.rank.shortTitle,
            sortKey: this.rank.sortKey,
            isActive: this.rank.isActive,
          });
        }
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
  },
};
</script>
